import type { ApprovalStatus, PiPaymentStatus } from "./types";

type Tone = "neutral" | "brand" | "brass" | "ok" | "warn" | "danger" | "info";

export const PAYMENT_TONE: Record<PiPaymentStatus, Tone> = {
  paid: "ok",
  partial: "warn",
  unpaid: "neutral",
};

export const APPROVAL_TONE: Record<ApprovalStatus, Tone> = {
  Approved: "ok",
  Pending: "warn",
  "Under Review": "info",
  Rejected: "danger",
};

/** Trạng thái đơn mua — danh sách đơn mua và khối chứng từ trên trang nhà cung cấp dùng chung. */
export const PO_STATUS_TONE: Record<string, Tone> = {
  Draft: "neutral",
  Sent: "info",
  Confirmed: "info",
  "Partially Delivered": "warn",
  Delivered: "ok",
  Cancelled: "danger",
};

/** Khiếu nại nhà cung cấp: đã phản hồi là chờ mình duyệt (vàng); đã duyệt, đã đóng là xong phần việc chính. */
export const SUPPLIER_CLAIM_TONE: Record<string, Tone> = {
  Draft: "neutral",
  Sent: "info",
  Responded: "warn",
  Approved: "ok",
  Closed: "ok",
  Cancelled: "danger",
};

/** Hoá đơn / phiếu chi / phiếu ghi nợ nhà cung cấp. */
export const GL_DOC_TONE: Record<string, Tone> = {
  Draft: "neutral",
  Posted: "ok",
  Reversed: "danger",
};


export function paymentProgress(paid: number, total: number): number {
  if (total <= 0) return 0;
  return Math.max(0, Math.min(1, paid / total));
}
